<template>
  <div>
    <div
      v-if="
        user.grant.users.list == true ||
        user.grant.users.create == true ||
        user.grant.users.update == true ||
        user.grant.users.delete == true ||
        user.grant.users.grant == true
      "
    >
      <add-user
        :isSidebarActive="showSidebar"
        :data="sidebarData"
        @closeSidebar="toggleSidebar"
        :editEl="editEl"
        :callBackAdd="callBackAdd"
      />
      <vs-table
        v-if="
          user.grant.users.list == true ||
          user.grant.users.update == true ||
          user.grant.users.grant == true
        "
        ref="table"
        :max-items="10"
        :data="users"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <div
              v-if="user.grant.users.create == true"
              @click="addNewUser"
              class="
                btn-add-new
                p-3
                mb-4
                mr-4
                rounded-lg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                text-base text-primary
                border border-solid border-primary
              "
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary"
                >Nouvel utilisateur</span
              >
            </div>
            <div
              @click="refresh"
              class="
                btn-add-new
                p-3
                mb-4
                mr-4
                rounded-lg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                text-base text-primary
                border border-solid border-primary
              "
            >
              <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Actualiser</span>
            </div>
          </div>
          <div class="con-input-search vs-table--search">
            <input
              placeholder="Rechercher par email / téléphone"
              @keyup.enter="getSearch()"
              v-model="model.search"
              type="text"
              class="input-search vs-table--search-input"
            />
            <i class="vs-icon notranslate icon-scale material-icons null"
              >search</i
            >
          </div>
        </div>

        <template slot="thead">
          <vs-th>Nom & Prénoms</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Profil</vs-th>
          <vs-th>Téléphone</vs-th>
          <vs-th>Créé le</vs-th>
          <vs-th
            v-if="
              user.grant.users.update == true ||
              user.grant.users.delete == true ||
              user.grant.users.grant == true
            "
            >Actions</vs-th
          >
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.last_name + " " + tr.first_name }}</vs-td>
              <vs-td>{{ tr.email }}</vs-td>
              <vs-td>{{
                tr.profile == "2" ? "Administrateur" : "Agent"
              }}</vs-td>
              <vs-td>{{ tr.phone }}</vs-td>
              <vs-td>{{ parseDate(tr.created_at) }}</vs-td>
              <vs-td
                class="whitespace-no-wrap"
                v-if="
                  user.grant.users.update == true ||
                  user.grant.users.delete == true ||
                  user.grant.users.grant == true
                "
              >
                <div class="flex">
                  <vx-tooltip text="Privilège">
                    <feather-icon
                      v-if="user.grant.users.grant == true"
                      style="cursor: pointer"
                      @click="
                        $router.push({ name: 'grant', params: { id: tr.id } })
                      "
                      icon="AwardIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    v-if="user.grant.users.update == true"
                    text="Modifier"
                  >
                    <feather-icon
                      style="cursor: pointer"
                      @click="edit(tr)"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Supprimer">
                    <feather-icon
                      v-if="user.grant.users.update == true && user_id != tr.id"
                      style="cursor: pointer"
                      @click="deleteUser(tr)"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="mr-2"
                    />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-pagination
        v-if="last_page && model.page"
        :total="last_page"
        v-model="model.page"
      ></vs-pagination>
    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div
          class="
            vx-col
            flex
            items-center
            justify-center
            flex-col
            sm:w-1/2
            md:w-3/5
            lg:w-3/4
            xl:w-1/2
            mx-auto
            text-center
          "
        >
          <img
            src="@/assets/images/pages/404.png"
            alt="graphic-404"
            class="mx-auto mb-4 max-w-full"
          />
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">
            404 - Page introuvable!
          </h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">
            La page que vous demandez est introuvable
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _buildQuery } from "../../helper/helper";
import auth from "../../helper/auth";
import moment from "moment";
import addUser from "./item/add.vue";
export default {
  components: { addUser },
  data() {
    return {
      showSidebar: false,
      sidebarData: {},
      users: [],
      last_page: null,
      model: {
        page: 1,
        search: "",
      },
      user_id: "",
      editEl: false,
      user: {},
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user_cnhu"));
  },
  watch: {
    "model.page": function () {
      this.loadUsers();
    },
  },
  mounted() {
    this.user_id = auth.getId();
    if (
      this.user.grant.users.list == true ||
      this.user.grant.users.update == true ||
      this.user.grant.users.delete == true
    ) {
      this.loadUsers();
    }
  },
  methods: {
    toggleSidebar(val = false) {
      this.showSidebar = val;
    },
    edit(data) {
      this.editEl = true;
      this.sidebarData = { ...data };
      this.toggleSidebar(true);
    },
    addNewUser() {
      this.editEl = false;
      this.sidebarData = {};
      this.toggleSidebar(true);
    },
    loadUsers() {
      this.$vs.loading();
      this.$http
        .get("users" + _buildQuery(this.model))
        .then((response) => {
          this.users = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "page-login" });
          }
        });
    },

    callBackAdd() {
      this.model.search = "";
      this.model.page = 1;
      this.loadUsers();
    },

    parseDate(date) {
      return moment(date).format("DD-MM-YYYY H:mm");
    },

    deleteUser(tr) {
      if (confirm("Voulez-vous supprimer l'utilisateur ?")) {
        this.$vs.loading();
        this.$http
          .post("users/remove", { id: tr.id })
          .then((re) => {
            if (re.data.status) {
              let index = this.users.indexOf(tr);
              this.users.splice(index, 1);
              this.$vs.notify({
                time: 5000,
                title: "Succès!",
                text: "Opération effectuée avec succès",
                color: "success",
                iconPack: "feather",
                position: "top-right",
                icon: "icon-check-circle",
              });
            }
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.$vs.loading.close();
            if (error.response.status === 401) {
              this.$vs.notify({
                title: "Erreur",
                text: "Votre session a expiré",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right",
              });
              this.$router.push({ name: "page-login" });
            }
          });
      }
    },
    getSearch() {
      this.model.page = 1;
      this.loadUsers();
    },
    refresh() {
      this.model.page = 1;
      this.model.search = "";
      this.loadUsers();
    },
  },
};
</script>
